<template>
  <div class="grid md:grid-cols-2">
    <div class="py-14 xl:py-20">
      <h4
        class="text-cLightBlue px-6 karla text-xl md:text-2xl font-light md:tracking-wide md:px-12 md:-mr-16 lg:px-20"
      >
        AWALI HARI DENGAN KEBAIKAN
      </h4>
      <hr
        class="w-8/12 md:w-11/12 xl:w-6/12 ml-6 md:ml-12 lg:ml-20 lg:w-8/12 xl:px-20 mt-2 border-cLightBlue border-1"
      />
      <hr
        class="w-8/12 lg:w-8/12 md:w-11/12 xl:w-6/12 ml-6 md:ml-12 lg:ml-20 xl:px-20 mt-0 border-cLightBlue border-1"
      />
      <h1
        class="text-cBlue text-2xl md:text-3xl px-6 md:px-12 lg:px-20 xl:px-20 source xl:text-5xl font-semibold mt-10"
      >
        Sedekah Kuy!
      </h1>
      <h1
        class="source text-2xl md:text-3xl mr-4 text-cBlue px-6 lg:px-20 md:px-12 xl:px-20 md:-mr-28 xl:text-5xl font-semibold"
      >
        Kuy Peduli, Kuy Berbagi, Berkah Menanti.
      </h1>
      <p
        class="text-cBlue px-6 text-sm md:px-12 xl:px-20 md:pt-3 lg:px-20 lg:-mr-28 md:text-xl mt-5 font-semibold"
      >
        Bersedekahlah, maka doa dari mereka akan selalu membawa kebaikan
        kepadamu.
      </p>
      <div class="px-6 mt-10 md:px-12 md:mt-10 lg:px-20 xl:px-20 lg:mt-16">
        <router-link to="#donasi" class="button-header">
          <button
            type="button"
            class="text-white py-1.5 px-2 my-2 text-sm md:text-lg md:mt-2 md:px-7 bg-cDarkBlue mr-4 border-2 border-cDarkBlue focus:outline-none hover:outline-none"
          >
            DONASI SEKARANG
          </button>
        </router-link>
        <router-link to="#tentang" class="button-header">
          <button
            type="button"
            class="text-cLightBlue text-sm my-2 md:text-lg px-2 py-1.5 md:px-7 border-2 border-cLightBlue md:mt-2 focus:outline-none hover:outline-none"
          >
            <div class="flex">
              PELAJARI LEBIH LANJUT <img src="../assets/mouse.svg" alt="" />
            </div>
          </button>
        </router-link>
      </div>
    </div>
    <img
      src="../assets/img-header.png"
      alt=""
      class="hidden md:block md:w-10/12 md:mt-24 md:ml-16 lg:ml-20 lg:mt-10 xl:w-10/12 xl:ml-28 xl:mt-4"
    />
  </div>
</template>

<script>
export default {
  name: "Beranda",
};
</script>

<style>
input[type="button"] {
  outline: none;
}

.button-header.router-link-active,
.button-header.router-link-exact-active {
  cursor: pointer;
  border-bottom: none;
}
</style>